<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <!-- el-tooltip v-if="iconType == 'new'" content="Transcript Information"-->
  <el-tooltip content="Transcript Information" class="info-item">
    <div ref="signalPopoverInfoRef" v-if="transcript.conversationId" :key="transcript.conversationId">
      <el-popover trigger="click" v-model="visible" popper-class="wy-panel-header-transcript-info-popover" ref="signalPopoverRef" placement="bottom-end" title="" width="340">
        <div class="signal-transcript-viewer-header-right">
          <div class="signal-popper-header">
            <div>Transcript Information</div>
            <img @click="closePopover" style="cursor: pointer; z-index:9999" src="../../assets/icons/icon_customer_close.svg" />
          </div>

          <div class="signal-margin" />

          <div class="scrollable-body">
            <div class="signal-popper-info" v-if="hasBesSignalIndicator(transcript)">
              <div class="title">BES Signals Identified</div>
              <div v-for="(signal, index) in mapTranscriptToBesSignals(transcript)" :key="index">{{ index + 1 }}. {{ signal }}</div>
            </div>

            <div class="signal-margin" v-if="hasBesSignalIndicator(transcript)" />

            <div class="signal-popper-info" v-if="hasBasSignalIndicator(transcript)">
              <div class="title">BAS Signals Identified</div>
              <div v-for="(signal, index) in mapTranscriptToBasSignals(transcript)" :key="index">{{ index + 1 }}. {{ signal }}</div>
            </div>

            <div class="signal-margin" v-if="hasBasSignalIndicator(transcript)" />

            <div class="signal-popper-info">
              <div class="title">Conversation Details</div>
              <div><span class="fw-500">ID: </span>{{ transcript.conversationId }}</div>
              <div><span class="fw-500">Topic: </span>{{transcript.topicDisplayName ? transcript.topicDisplayName : 'No topic found' }}</div>
              <div>
                <span class="fw-500">Handled by: </span>
                <span v-if="transcript.conversationType == 'BotOnlyContained'">VA contained</span>
                <span v-if="transcript.conversationType == 'BotToLC'">VA engaged with live agent connected</span>
                <span v-if="transcript.conversationType == 'LCOnly'">VA only</span>
                <span v-if="transcript.conversationType == 'BotOnlyEscalated'">Live agent requested but not connected</span>
              </div>
              <div><span class="fw-500">Handling time: </span>{{ handleTimeInNiceFormat(transcript.handleTimeMillis) }}</div>
              <div><span class="fw-500">Channel: </span>{{ convertTranscriptCustType(transcript.custType) }}</div>
            </div>

            <div v-if="hasAgentId(transcript) || hasAgentQueue(transcript) || hasAgentGroup(transcript)" class="signal-margin" />

            <div v-if="hasAgentId(transcript) || hasAgentQueue(transcript) || hasAgentGroup(transcript)" class="signal-popper-info" style="padding-bottom: 16px">
              <div class="title">Agent Details</div>
              <div v-if="hasAgentId(transcript)"><span class="fw-500">ID: </span>{{ transcript.agentId }}</div>
              <div v-if="hasAgentQueue(transcript)"><span class="fw-500">Queue: </span>{{ transcript.agentQueue }}</div>
              <div v-if="hasAgentGroup(transcript)"><span class="fw-500">Group: </span>{{ transcript.agentGroup }}</div>
            </div>
          </div>
        </div>
        <el-button @click="clickInfo" slot="reference" :class="{ 'summary-icon-hidden':!isTranscriptSummaryEnabled, 'el-infor-icon': iconType !== 'new', 'el-infor-icon-metricAnalysis': iconType === 'new' }"></el-button>
        <!--el-button @click="clickInfo" slot="reference" :class="{ 'el-infor-icon-metricAnalysis': iconType !== 'new', 'el-infor-icon-metricAnalysis': iconType === 'new' }"></el-button-->
      </el-popover>
    </div>
  </el-tooltip>

  <!-- old template no longer used for OC-1805 >
  <div v-else>
    <div ref="signalPopoverInfoRef" v-if="transcript.conversationId" :key="transcript.conversationId">
      <el-popover placement="top" title="" width="280" popper-class="contact-reason-transcript-tab-info-pop-over" trigger="hover">
        <div class="transcripts-viewer-header-right">
          <div class="popper-item">
            <b>Conversation ID</b><br />
            {{ transcript.conversationId }}
          </div>
          <div class="popper-item" v-if="transcript.agentId !== '--'">
            <b>Agent ID</b><br />
            {{ transcript.agentId }}
          </div>
          <div class="popper-item" v-if="transcript.conversationType !== '--'">
            <b>Handling type</b><br />
            <span v-if="transcript.conversationType == 'BotOnlyContained'"> VA contained</span>
            <span v-if="transcript.conversationType == 'BotToLC'">VA engaged with live agent connected</span>
            <span v-if="transcript.conversationType == 'LCOnly'">VA only</span>
            <span v-if="transcript.conversationType == 'BotOnlyEscalated'">Live agent requested but not connected</span>
          </div>
          <div class="popper-item" v-if="transcript.custType !== '--'">
            <b>Channel</b><br />
            {{ convertTranscriptCustType(transcript.custType) }}
          </div>
          <div class="popper-item" v-if="transcript.agentQueue !== '--'">
            <b>Agent queue</b><br />
            {{ transcript.agentQueue }}
          </div>
          <div class="popper-item" v-if="transcript.agentGroup !== '--'">
            <b>Agent group</b><br />
            {{ transcript.agentGroup }}
          </div>
          <div class="popper-item" v-if="transcript.handleTimeMillis !== '--'">
            <b>Handling time</b><br />
            {{ handleTimeInNiceFormat(transcript.handleTimeMillis) }}
          </div>
        </div>
        <el-button @click="clickInfo" slot="reference" :class="{ 'el-infor-icon': iconType !== 'new', 'el-infor-icon-metricAnalysis': iconType === 'new' }"></el-button>
      </el-popover>
    </div>
  </div>
  -->
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapMutations } from 'vuex';
import WyUtils from '../../library/wy-utils';

export default Vue.extend({
  name: 'wy-panel-header-transcript-info',
  props: {
    transcript: {
      type: Object,
      required: true,
    },
    iconType: {
      type: String,
      required: false,
    },
    isTranscriptSummaryEnabled: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: false,
    };
  },

  computed: {
    ...mapGetters(['transcriptInfoReference', 'companyConfig']),
  },
  methods: {
    ...mapMutations(['updateTranscriptInfoReference']),

    convertTranscriptCustType(custType) {
      const custTypesMap = (this.companyConfig && this.companyConfig.app && this.companyConfig.app.configs && this.companyConfig.app.configs.channelsMapping) || {};
      if (!custTypesMap[custType]) {
        return WyUtils.toCamelCase(custType);
      }

      return custTypesMap[custType];
    },

    clickInfo() {
      if(!this.visible) {
        setTimeout(() => {
          this.visible = true;
          this.updateTranscriptInfoReference(this);
          this.$router.logAmplitudeEvent({ eventName: 'transcript_info_show', filterProperties: false });
        }, 500);
      }
    },
    closePopover() {
      this.visible = false;
      this.updateTranscriptInfoReference(null);
    },
    hasBesSignalIndicator(transcript) {
      return (
        (transcript.isAbandoned > 0) ||
        (transcript.hasBotEndNegativeSentiment > 0) ||
        Boolean(transcript.numOfRepeatUserEscalation) ||
        Boolean(transcript.numOfNegativeFeedback) ||
        Boolean(transcript.numOfProfanity) ||
        Boolean(transcript.numOfUserDitto) ||
        Boolean(transcript.numOfBotDitto)
      );
    },
    hasBasSignalIndicator(transcript) {
      return (transcript.isAbandoned > 0) || (transcript.isEscalated > 0) || (transcript.hasFailedEscalationRequest > 0) || (transcript.hasFalsePositive > 0) || Boolean(transcript.numOfNegativeFeedback);
    },
    hasAgentId(transcript) {
      return transcript.agentId !== '--' &&  transcript.agentId != null;
    },
    hasAgentQueue(transcript) {
      return transcript.agentQueue !== '--' &&  transcript.agentQueue != null;
    },
    hasAgentGroup(transcript) {
      return transcript.agentGroup !== '--' &&  transcript.agentGroup != null
    },
    mapTranscriptToBesSignals(transcript) {
      const signals = [];
      if (transcript.isAbandoned) {
        signals.push('User Abandoned');
      }
      if (transcript.hasBotEndNegativeSentiment) {
        signals.push('Negative Sentiment');
      }
      if (transcript.numOfRepeatUserEscalation) {
        signals.push('Repeated Escalation Requests');
      }
      if (transcript.numOfNegativeFeedback) {
        signals.push('Negative Feedback');
      }
      if (transcript.numOfProfanity) {
        signals.push('Profanity');
      }
      if (transcript.numOfUserDitto) {
        signals.push('User Paraphrases');
      }
      if (transcript.numOfBotDitto) {
        signals.push('Bot Repetition');
      }
      return signals;
    },
    mapTranscriptToBasSignals(transcript) {
      const signals = [];
      if (transcript.isAbandoned) {
        signals.push('User Abandoned');
      }
      if (transcript.isEscalated) {
        signals.push('Escalation');
      }
      if (transcript.hasFailedEscalationRequest) {
        signals.push('Escalation not Connected');
      }
      if (transcript.hasFalsePositive) {
        signals.push('False Positives');
      }
      if (transcript.numOfNegativeFeedback) {
        signals.push('Negative Feedback');
      }
      return signals;
    },

    handleTimeInNiceFormat(Millis) {
      let seconds = Millis / 1000;

      return WyUtils.toNiceTimeFormat(seconds);
    },
  },

  mounted() {
    this.$root.$on('close-popover', () => {
      this.visible = false;
    });
  },
});
</script>

<style lang="scss">
  .wy-analytics-transcript-search-expand {
    .el-tooltip.info-item {
      position: relative;
      line-height: 0;
      top: -10px;
      .el-infor-icon, .el-infor-icon-metricAnalysis {
        top: 17px !important;
      }
      .summary-icon-hidden.el-infor-icon {
        left: 12px !important;
      }
    }
  }
  .el-tooltip.info-item {
    position: relative;
    line-height: 0;
    // top: -10px;
  }
.wy-panel-header-transcript-info-popover {
  // padding: 20px;
  max-height: 349px;
  padding-bottom: 0px;
  padding: 25px 30px 0px 30px;
}

.signal-transcript-viewer-header-right {
  color: var(--site-font-chart-color);
  font-size: 14.22px;
  font-style: normal;
  font-weight: 400;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif !important;

  .signal-popper-header {
    display: flex;
    align-content: center;
    justify-content: space-between;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    margin-top: -8px;
    padding-bottom: 15px;
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif !important;
  }

  .scrollable-body {
    overflow: auto;
    overflow-x: hidden;

    max-height: 314px;
    width: 390px;

    margin-left: -30px;
    margin-bottom: 0px;
    padding-bottom: 0px;
    padding-right: 10px;

    &::-webkit-scrollbar {
      width: 16px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 160px;
      border: 4px solid transparent;

      background-clip: content-box;
      background-color: #cad2da;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
      border: 1px solid #cad2da;
      border-top: none;
      border-bottom: none;
    }
  }

  .signal-popper-info {
    display: flex;
    flex-direction: column;
    gap: 8px;
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif !important;
    padding-left: 30px;
    padding-top: 16px;
    padding-bottom: 16px;
    word-break: break-word;

    .title {
      font-size: 14.22px;
      font-style: normal;
      font-weight: 700;
    }
    .fw-500 {
      font-weight: 500;
    }
  }
  .agent-info {
    margin-bottom: -10px;
  }
  .signal-margin {
    margin: 0px -30px;
    border-bottom: 1px solid #cad2da;
  }
}

.wy-analytics-contact-reasons-detail-topic-relations, .wy-analytics-contact-reasons-detail-topic-group, .wy-analytics-contact-reasons-detail-topic-messages {
  .message-transcripts-section .div-message-transcripts-viewer-header {
    .el-tooltip.save-item {
      line-height: 0;
      position: relative;
      left: 17px;
      // top: 7px;
    }
    .el-infor-icon {
      left: 2px !important;
      top: 2px !important;
    }
    .summary-icon {
      left: 10px !important;
      // left: 5px !important;
      top: 3px !important;
    }
    .saved-transcript-grey-star, .saved-transcript-golden-star, .summary-icon,  .el-infor-icon {
      background-size: 100%;
      background-repeat: no-repeat;
      background-position-y: 0px;
      background-position-x: 0px;
      height: 20px;
      width: 20px;
      border: 0px;
      margin: 0px !important;
      padding: 0px !important;
      // left: 2px !important;
      // top: -4px !important;
      position: relative;
      border-radius: 0px;
    }
    .saved-transcript-grey-star, .saved-transcript-golden-star{
      left: 17px !important;
      top: 3px !important;
    }
  }
}

.wy-analytics-contact-reasons-detail-topic-messages {
  .message-transcripts-section .div-message-transcripts-viewer-header {
    .div-saved-transcript .el-tooltip {
      position: relative;
      left: 10px !important;
      line-height: 0;
      .el-button.saved-transcript-grey-star,.el-button.saved-transcript-golden-star {
        // left: 0px !important;
        left: 7px !important;
      }
      
    }
    .el-tooltip.summary-icon-hidden {
      .el-button.saved-transcript-grey-star,.el-button.saved-transcript-golden-star {
        left: 0px !important;
      }
    }
  }
}
.wy-analytics-contact-reasons-detail-topic-relations {
  .message-transcripts-section .div-message-transcripts-viewer-header .el-tooltip.save-item {
    line-height: 0;
    left: 17px !important;
    .el-button.saved-transcript-grey-star,.el-button.saved-transcript-golden-star {
      left: 0px !important;
    }
  }
}

.wy-analytics-contact-reasons-detail-topic-group {
  .message-transcripts-section .div-message-transcripts-viewer-header .el-tooltip.save-item {
    line-height: 0;
    left: 17px !important;
    .el-button.saved-transcript-grey-star,.el-button.saved-transcript-golden-star {
      left: 0px !important;
    }
  }
  .message-transcripts-section .div-message-transcripts-viewer-header .el-tooltip.save-item.summary-icon-hidden {
    left: 10px !important;
  }
}
.wy-analytics-transcript-search-details, .wy-interactions-transcript-search-details {
  .div-transcript-header {
    .el-infor-icon-metricAnalysis {
      cursor: pointer;
      background-image: url('../../assets/icons/icon_transcript_search_info_new.svg');
      background-size: 100%;
      background-repeat: no-repeat;
      background-position-y: 0px;
      background-position-x: 0px;
      height: 20px;
      width: 20px;
      border: 0px;
      margin: 0px !important;
      padding: 0px !important;
      left: 8px;
      top: 1px;
      position: relative;
      border-radius: 0px;
    }
    .summary-icon-hidden.el-infor-icon {
      left: 2px !important;
    }
    .el-infor-icon {
      cursor: pointer;
      //background-image: url('../../assets/icons/icon_transcript_search_info.svg');
      background-image: url('../../assets/icons/icon_transcript_search_info_new.svg');
      background-size: 100%;
      background-repeat: no-repeat;
      background-position-y: 0px;
      background-position-x: 0px;
      height: 20px;
      width: 20px;
      border: 0px;
      margin: 0px !important;
      padding: 0px !important;
      left: -5px;
      top: 1px;
      position: absolute;
      border-radius: 0px;
    }
  }
}
  
.wy-analytics-contact-reasons-detail {
  .el-infor-icon-metricAnalysis {
    cursor: pointer;
    background-image: url('../../assets/icons/icon_transcript_search_info_new.svg');
    background-size: 100%;
    background-repeat: no-repeat;
    background-position-y: 0px;
    background-position-x: 0px;
    height: 20px;
    width: 20px;
    border: 0px;
    margin: 0px !important;
    padding: 0px !important;
    left: 8px;
    top: 1px;
    position: relative;
    position: relative;
    border-radius: 0px;
  }

  .summary-icon-hidden.el-infor-icon-metricAnalysis {
    left: 12px;
  }

  .el-infor-icon {
    cursor: pointer;
    background-image: url('../../assets/icons/icon_transcript_search_info_new.svg');
    background-size: 100%;
    background-repeat: no-repeat;
    background-position-y: 0px;
    background-position-x: 0px;
    height: 20px;
    width: 20px;
    border: 0px;
    margin: 0px !important;
    padding: 0px !important;
    left: 8px;
    top: 1px;
    position: relative;
    border-radius: 0px;
  }
}

.wy-analytics-transcript-search-expand .div-transcript-header {
  .el-infor-icon {
    cursor: pointer;
    background-image: url('../../assets/icons/icon_transcript_search_info_new.svg');
    background-size: 100%;
    background-repeat: no-repeat;
    background-position-y: 0px;
    background-position-x: 0px;
    height: 20px;
    width: 20px;
    border: 0px;
    margin: 0px !important;
    padding: 0px !important;
    left: 8px;
    top: 1px;
    position: relative;
    border-radius: 0px;
  }
}

.message-transcripts-section .div-message-transcripts-viewer-header {
  .el-infor-icon-metricAnalysis {
    cursor: pointer;
    background-image: url('../../assets/icons/icon_transcript_search_info_new.svg');
    background-size: 100%;
    background-repeat: no-repeat;
    background-position-y: 0px;
    background-position-x: 0px;
    height: 20px;
    width: 20px;
    border: 0px;
    margin: 0px !important;
    padding: 0px !important;
    left: 8px;
    top: 1px;
    position: relative;
    border-radius: 0px;
  }

  .el-infor-icon {
    cursor: pointer;
    background-image: url('../../assets/icons/icon_transcript_search_info_new.svg');
    background-size: 100%;
    background-repeat: no-repeat;
    background-position-y: 0px;
    background-position-x: 0px;
    height: 20px;
    width: 20px;
    border: 0px;
    // margin: 0px !important;
    margin-top: 6px;
    padding: 0px !important;
    left: 8px;
    top: 1px;
    position: relative;
    border-radius: 0px;
  }
}
</style>
